import { render, staticRenderFns } from "./gameScoresTable.vue?vue&type=template&id=37f857ee&scoped=true"
import script from "./gameScoresTable.vue?vue&type=script&lang=js"
export * from "./gameScoresTable.vue?vue&type=script&lang=js"
import style0 from "./gameScoresTable.vue?vue&type=style&index=0&id=37f857ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f857ee",
  null
  
)

export default component.exports